import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import SeoHead, { SITE_URL } from '@/components/feature/SeoHead';

const LOGO = 'https://public.readdy.ai/ai/img_res/1641229f-de9d-42a9-901f-6e578c489111.png';

const legalInfo = [
  { label: 'Полное наименование', value: 'Общество с ограниченной ответственностью Аптека-А.в.е-1' },
  { label: 'Юридический адрес', value: '121108, город Москва, муниципальный округ Фили-Давыдково вн.тер.г., ул. Ивана Франко, дом 8, 18-й этаж, помещение № I, комната № 47, офис № 3' },
  { label: 'Почтовый адрес', value: '121108, город Москва, ул. Ивана Франко, дом 8, 19-й этаж' },
  { label: 'Лицензия', value: '№ЛО42-01158-40/00284248 выдана 15.02.2021 г.' },
  { label: 'ИНН', value: '7714844316' },
  { label: 'ОГРН', value: '1105321000102' },
];

const contactSections = [
  {
    id: 'support',
    icon: 'ri-customer-service-2-line',
    color: '#ff2d78',
    title: 'Связаться с нами',
    description: 'Любые вопросы, связанные с оформлением и исполнением заказа, вы можете задать по телефону:',
    items: [
      { type: 'phone', label: '8 499 653 6 277', sub: 'в Москве', href: 'tel:84996536277' },
      { type: 'phone', label: '8 800 700 9 300', sub: 'в Санкт-Петербурге (бесплатно)', href: 'tel:88007009300' },
      { type: 'text', label: 'Наш клиентский центр работает круглосуточно.' },
      { type: 'email', label: 'feedback@gorzdrav.org', sub: 'Круглосуточный приём вопросов, претензий, предложений', href: 'mailto:feedback@gorzdrav.org' },
    ],
  },
  {
    id: 'office',
    icon: 'ri-building-2-line',
    color: '#00f5ff',
    title: 'Центральный офис',
    description: '',
    items: [
      { type: 'address', label: 'Россия, 121108, Москва, ул. Ивана Франко, д. 8, БЦ Kutuzoff Tower, 18 этаж.' },
      { type: 'hours', label: 'Пн–Пт: 10:00–18:00', sub: 'Сб–Вс: выходной' },
      { type: 'text', label: 'Офис не осуществляет выдачу заказов. Посещение только по предварительной записи.' },
    ],
  },
  {
    id: 'manufacturers',
    icon: 'ri-flask-line',
    color: '#39ff14',
    title: 'Взаимодействие с производителями',
    description: 'Коммерческие предложения от производителей лекарственных препаратов и БАД:',
    items: [
      { type: 'email', label: 'commercial@gorzdrav.org', href: 'mailto:commercial@gorzdrav.org' },
    ],
  },
  {
    id: 'rent',
    icon: 'ri-store-2-line',
    color: '#f0ff00',
    title: 'Аренда',
    description: 'Требования к помещениям: формат 40–150 кв.м, расположение на 1 этаже, наличие санузла или точек подключения, наличие центральной системы кондиционирования. Также готовы рассмотреть площади в действующих или новых, строящихся торговых центрах.',
    items: [
      { type: 'email', label: 'arenda@gorzdrav.org', href: 'mailto:arenda@gorzdrav.org' },
    ],
  },
  {
    id: 'sublease',
    icon: 'ri-home-office-line',
    color: '#ff6b00',
    title: 'Субаренда (аренда площадей у аптек)',
    description: 'В наличии площади от 3 до 100 кв.м.',
    items: [
      { type: 'phone', label: '+7 (495) 797-86-86', sub: 'доб. 1088, 1084, 1026, 1272', href: 'tel:+74957978686' },
      { type: 'phone', label: '+7 (915) 083-56-63', href: 'tel:+79150835663' },
      { type: 'email', label: 'subarenda@gorzdrav.org', href: 'mailto:subarenda@gorzdrav.org' },
    ],
  },
];

const contactsJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  name: 'Контакты NeonPharma',
  description: 'Контактная информация интернет-аптеки NeonPharma: телефоны, email, адрес офиса, форма обратной связи.',
  url: `${SITE_URL}/contacts`,
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Главная', item: SITE_URL },
      { '@type': 'ListItem', position: 2, name: 'Контакты', item: `${SITE_URL}/contacts` },
    ],
  },
  mainEntity: {
    '@type': 'LocalBusiness',
    name: 'NeonPharma',
    telephone: ['+74996536277', '+78007009300'],
    email: 'feedback@gorzdrav.org',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'ул. Ивана Франко, д. 8, БЦ Kutuzoff Tower, 18 этаж',
      addressLocality: 'Москва',
      postalCode: '121108',
      addressCountry: 'RU',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 55.7441,
      longitude: 37.3897,
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        opens: '00:00',
        closes: '23:59',
      },
    ],
    url: SITE_URL,
  },
};

const ContactsPage = () => {
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [activeSection, setActiveSection] = useState<string | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.message) return;
    setSubmitting(true);
    try {
      const body = new URLSearchParams();
      body.append('name', formData.name);
      body.append('email', formData.email);
      body.append('subject', formData.subject);
      body.append('message', formData.message);
      await fetch('https://readdy.ai/api/form/d796ms2dqn9mib2tr0h0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen" style={{ background: '#050508' }}>
      <SeoHead
        title="Контакты NeonPharma — телефон, email, адрес офиса"
        description="Контакты интернет-аптеки NeonPharma: 8 499 653 6 277, feedback@gorzdrav.org. Офис: Москва, ул. Ивана Франко, д. 8. Работаем круглосуточно 24/7."
        keywords="контакты аптеки, телефон NeonPharma, адрес аптеки, обратная связь"
        canonical="/contacts"
        jsonLd={contactsJsonLd}
      />
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-16 px-6 lg:px-12 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/550f37a418e0a1344ad8bd6092816af4.jpg"
            alt="Контакты"
            className="w-full h-full object-cover object-top opacity-20"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-[#050508]" />
        </div>

        {/* Breadcrumb */}
        <div className="relative z-10 max-w-7xl mx-auto mb-8">
          <div className="flex items-center gap-2 font-mono text-xs text-white/30">
            <Link to="/" className="hover:text-neon-cyan transition-colors">Главная</Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-neon-cyan">Контакты</span>
          </div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto">
          <div className="flex items-center gap-4 mb-4">
            <div className="w-1 h-12 rounded-full" style={{ background: 'linear-gradient(to bottom, #ff2d78, #00f5ff)' }} />
            <div>
              <p className="font-mono text-xs tracking-[0.3em] text-neon-cyan/70 mb-1">КОНТАКТНЫЕ ДАННЫЕ</p>
              <h1 className="font-orbitron font-black text-4xl md:text-6xl text-white">
                КОНТАКТЫ
              </h1>
            </div>
          </div>
          <p className="font-mono text-sm text-white/40 max-w-xl ml-5 pl-4">
            Мы работаем круглосуточно. Свяжитесь с нами любым удобным способом.
          </p>
        </div>
      </section>

      {/* Contact Cards Grid */}
      <section className="px-6 lg:px-12 pb-16">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
          {contactSections.map((section) => (
            <div
              key={section.id}
              className="card-cyber rounded-2xl p-6 group cursor-pointer transition-all duration-300"
              style={{ borderColor: `${section.color}20` }}
              onClick={() => setActiveSection(activeSection === section.id ? null : section.id)}
            >
              {/* Header */}
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div
                    className="w-10 h-10 flex items-center justify-center rounded-xl"
                    style={{ background: `${section.color}15`, border: `1px solid ${section.color}40` }}
                  >
                    <i className={`${section.icon} text-lg`} style={{ color: section.color }} />
                  </div>
                  <h2
                    className="font-orbitron font-bold text-sm text-white leading-tight"
                    style={{ textShadow: activeSection === section.id ? `0 0 10px ${section.color}` : 'none' }}
                  >
                    {section.title}
                  </h2>
                </div>
                {activeSection === section.id
                  ? <i className="ri-arrow-up-s-line text-white/30 transition-transform" />
                  : <i className="ri-arrow-down-s-line text-white/30 transition-transform" />
                }
              </div>

              {section.description && (
                <p className="font-mono text-xs text-white/40 leading-relaxed mb-4">
                  {section.description}
                </p>
              )}

              {/* Items */}
              <div className="space-y-3">
                {section.items.map((item, idx) => (
                  <div key={idx}>
                    {item.type === 'phone' && (
                      <a
                        href={item.href}
                        onClick={(e) => e.stopPropagation()}
                        className="flex items-start gap-3 group/item"
                      >
                        <div className="w-6 h-6 flex items-center justify-center shrink-0 mt-0.5">
                          <i className="ri-phone-line text-sm" style={{ color: section.color }} />
                        </div>
                        <div>
                          <span
                            className="font-orbitron font-bold text-sm transition-all"
                            style={{ color: section.color, textShadow: `0 0 8px ${section.color}60` }}
                          >
                            {item.label}
                          </span>
                          {item.sub && <p className="font-mono text-xs text-white/30 mt-0.5">{item.sub}</p>}
                        </div>
                      </a>
                    )}
                    {item.type === 'email' && (
                      <a
                        href={item.href}
                        onClick={(e) => e.stopPropagation()}
                        className="flex items-start gap-3"
                      >
                        <div className="w-6 h-6 flex items-center justify-center shrink-0 mt-0.5">
                          <i className="ri-mail-line text-sm" style={{ color: section.color }} />
                        </div>
                        <div>
                          <span
                            className="font-mono text-sm transition-all hover:underline"
                            style={{ color: section.color }}
                          >
                            {item.label}
                          </span>
                          {item.sub && <p className="font-mono text-xs text-white/30 mt-0.5">{item.sub}</p>}
                        </div>
                      </a>
                    )}
                    {item.type === 'address' && (
                      <div className="flex items-start gap-3">
                        <div className="w-6 h-6 flex items-center justify-center shrink-0 mt-0.5">
                          <i className="ri-map-pin-line text-sm" style={{ color: section.color }} />
                        </div>
                        <span className="font-mono text-xs text-white/60 leading-relaxed">{item.label}</span>
                      </div>
                    )}
                    {item.type === 'hours' && (
                      <div className="flex items-start gap-3">
                        <div className="w-6 h-6 flex items-center justify-center shrink-0 mt-0.5">
                          <i className="ri-time-line text-sm" style={{ color: section.color }} />
                        </div>
                        <div>
                          <span className="font-mono text-xs text-white/60">{item.label}</span>
                          {item.sub && <p className="font-mono text-xs text-white/30 mt-0.5">{item.sub}</p>}
                        </div>
                      </div>
                    )}
                    {item.type === 'text' && (
                      <p className="font-mono text-xs text-white/30 leading-relaxed pl-9">{item.label}</p>
                    )}
                  </div>
                ))}
              </div>

              {/* Accent line */}
              <div
                className="absolute bottom-0 left-0 right-0 h-0.5 rounded-b-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                style={{ background: `linear-gradient(90deg, transparent, ${section.color}, transparent)` }}
              />
            </div>
          ))}
        </div>
      </section>

      {/* Map + Form */}
      <section className="px-6 lg:px-12 pb-16">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-6">

          {/* Map */}
          <div className="card-cyber rounded-2xl overflow-hidden" style={{ minHeight: '420px' }}>
            <div className="p-5 border-b border-white/5">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg" style={{ background: '#00f5ff15', border: '1px solid #00f5ff40' }}>
                  <i className="ri-map-pin-2-line text-sm" style={{ color: '#00f5ff' }} />
                </div>
                <div>
                  <h3 className="font-orbitron font-bold text-sm text-white">Центральный офис</h3>
                  <p className="font-mono text-xs text-white/30">Москва, ул. Ивана Франко, д. 8</p>
                </div>
              </div>
            </div>
            <div className="w-full h-80">
              <iframe
                title="Офис Горздрав на карте"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2245.3!2d37.3897!3d55.7441!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46b54b5e5e5e5e5e%3A0x0!2z0YPQuy4g0JjQstCw0L3QsCDQpNGA0LDQvdC60L4sIDgsINCc0L7RgdC60LLQsA!5e0!3m2!1sru!2sru!4v1700000000000!5m2!1sru!2sru&q=Москва,+ул.+Ивана+Франко,+д.+8,+БЦ+Kutuzoff+Tower"
                width="100%"
                height="100%"
                style={{ border: 0, filter: 'invert(90%) hue-rotate(180deg) saturate(0.7)' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>

          {/* Feedback Form */}
          <div className="card-cyber rounded-2xl p-6" style={{ borderColor: '#ff2d7820' }}>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg" style={{ background: '#ff2d7815', border: '1px solid #ff2d7840' }}>
                <i className="ri-message-3-line text-sm" style={{ color: '#ff2d78' }} />
              </div>
              <div>
                <h3 className="font-orbitron font-bold text-sm text-white">Обратная связь</h3>
                <p className="font-mono text-xs text-white/30">Ответим в течение 24 часов</p>
              </div>
            </div>

            {submitted ? (
              <div className="flex flex-col items-center justify-center py-12 text-center">
                <div
                  className="w-16 h-16 flex items-center justify-center rounded-full mb-4"
                  style={{ background: '#39ff1415', border: '1px solid #39ff1440' }}
                >
                  <i className="ri-check-line text-3xl" style={{ color: '#39ff14', textShadow: '0 0 15px #39ff14' }} />
                </div>
                <h4 className="font-orbitron font-bold text-white mb-2">Сообщение отправлено!</h4>
                <p className="font-mono text-xs text-white/40">Мы свяжемся с вами в ближайшее время.</p>
                <button
                  onClick={() => { setSubmitted(false); setFormData({ name: '', email: '', subject: '', message: '' }); }}
                  className="whitespace-nowrap mt-6 px-6 py-2.5 rounded-full font-mono text-xs tracking-wider cursor-pointer transition-all"
                  style={{ border: '1px solid #ff2d78', color: '#ff2d78' }}
                >
                  Отправить ещё
                </button>
              </div>
            ) : (
              <form
                data-readdy-form
                onSubmit={handleSubmit}
                className="space-y-4"
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block font-mono text-xs text-white/40 mb-1.5">Ваше имя *</label>
                    <input
                      type="text"
                      name="name"
                      required
                      value={formData.name}
                      onChange={(e) => setFormData((p) => ({ ...p, name: e.target.value }))}
                      placeholder="Иван Иванов"
                      className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 font-mono text-sm text-white placeholder-white/20 outline-none focus:border-neon-pink/60 transition-all"
                    />
                  </div>
                  <div>
                    <label className="block font-mono text-xs text-white/40 mb-1.5">Email *</label>
                    <input
                      type="email"
                      name="email"
                      required
                      value={formData.email}
                      onChange={(e) => setFormData((p) => ({ ...p, email: e.target.value }))}
                      placeholder="your@email.com"
                      className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 font-mono text-sm text-white placeholder-white/20 outline-none focus:border-neon-pink/60 transition-all"
                    />
                  </div>
                </div>
                <div>
                  <label className="block font-mono text-xs text-white/40 mb-1.5">Тема обращения</label>
                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={(e) => setFormData((p) => ({ ...p, subject: e.target.value }))}
                    placeholder="Вопрос по заказу / Предложение / Жалоба"
                    className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 font-mono text-sm text-white placeholder-white/20 outline-none focus:border-neon-pink/60 transition-all"
                  />
                </div>
                <div>
                  <label className="block font-mono text-xs text-white/40 mb-1.5">Сообщение * <span className="text-white/20">({formData.message.length}/500)</span></label>
                  <textarea
                    name="message"
                    required
                    maxLength={500}
                    rows={5}
                    value={formData.message}
                    onChange={(e) => setFormData((p) => ({ ...p, message: e.target.value }))}
                    placeholder="Опишите ваш вопрос или предложение..."
                    className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 font-mono text-sm text-white placeholder-white/20 outline-none focus:border-neon-pink/60 transition-all resize-none"
                  />
                </div>
                <button
                  type="submit"
                  disabled={submitting}
                  className="whitespace-nowrap w-full py-3.5 rounded-xl font-orbitron font-bold text-sm tracking-widest cursor-pointer transition-all duration-300"
                  style={{
                    background: submitting ? 'rgba(255,45,120,0.3)' : '#ff2d78',
                    color: '#fff',
                    boxShadow: submitting ? 'none' : '0 0 20px rgba(255,45,120,0.4)',
                  }}
                >
                  {submitting ? 'ОТПРАВКА...' : 'ОТПРАВИТЬ СООБЩЕНИЕ'}
                  <i className={`ml-2 ${submitting ? 'ri-loader-4-line animate-spin' : 'ri-send-plane-line'}`} />
                </button>
              </form>
            )}
          </div>
        </div>
      </section>

      {/* Legal Info */}
      <section className="px-6 lg:px-12 pb-16">
        <div className="max-w-7xl mx-auto">
          <div className="card-cyber rounded-2xl p-6 md:p-8" style={{ borderColor: '#f0ff0020' }}>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg" style={{ background: '#f0ff0015', border: '1px solid #f0ff0040' }}>
                <i className="ri-file-text-line text-sm" style={{ color: '#f0ff00' }} />
              </div>
              <h2 className="font-orbitron font-bold text-sm text-white">Юридическая информация</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-0 divide-y divide-white/5">
              {legalInfo.map((item) => (
                <div key={item.label} className="py-4 flex flex-col sm:flex-row gap-2 sm:gap-6">
                  <span className="font-mono text-xs text-white/30 shrink-0 sm:w-44">{item.label}</span>
                  <span className="font-mono text-xs text-white/70 leading-relaxed">{item.value}</span>
                </div>
              ))}
            </div>

            <div
              className="mt-6 p-4 rounded-xl"
              style={{ background: 'rgba(240,255,0,0.05)', border: '1px solid rgba(240,255,0,0.15)' }}
            >
              <div className="flex items-start gap-3">
                <i className="ri-information-line text-sm mt-0.5" style={{ color: '#f0ff00' }} />
                <p className="font-mono text-xs text-white/50 leading-relaxed">
                  Уважаемые покупатели, обращаем внимание, что офис компании не осуществляет выдачу заказов и не является аптекой.{' '}
                  <strong className="text-white/70">Посещение возможно только по предварительной записи.</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Specialist Block */}
      <section className="px-6 lg:px-12 pb-20">
        <div className="max-w-7xl mx-auto">
          <div
            className="rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-center gap-6"
            style={{ background: 'linear-gradient(135deg, rgba(0,245,255,0.05) 0%, rgba(57,255,20,0.05) 100%)', border: '1px solid rgba(0,245,255,0.15)' }}
          >
            <div className="w-20 h-20 rounded-full overflow-hidden shrink-0 border-2" style={{ borderColor: '#00f5ff40' }}>
              <img
                src="https://readdy.ai/api/search-image?query=professional%20female%20pharmacist%20portrait%20white%20coat%20friendly%20smile%20clean%20studio%20background%20medical%20specialist%20headshot&width=200&height=200&seq=specialist-avatar&orientation=squarish"
                alt="Провизор Золина Татьяна Олеговна"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="flex-1 text-center md:text-left">
              <div className="flex items-center gap-2 justify-center md:justify-start mb-1">
                <i className="ri-shield-check-line text-sm" style={{ color: '#39ff14' }} />
                <span className="font-mono text-xs text-white/40 tracking-wider">ПРОВЕРЕНО СПЕЦИАЛИСТОМ</span>
              </div>
              <h3 className="font-orbitron font-bold text-white mb-1">Золина Татьяна Олеговна</h3>
              <p className="font-mono text-xs text-white/50 mb-1">Провизор, стаж с 2009 года</p>
              <p className="font-mono text-xs text-white/30">
                Образование: Саратовский государственный медицинский университет им. В.И. Разумовского (СГМУ)
              </p>
            </div>
            <div
              className="px-5 py-3 rounded-xl text-center shrink-0"
              style={{ background: 'rgba(57,255,20,0.1)', border: '1px solid rgba(57,255,20,0.3)' }}
            >
              <i className="ri-verified-badge-line text-2xl block mb-1" style={{ color: '#39ff14', textShadow: '0 0 15px #39ff14' }} />
              <span className="font-mono text-xs text-white/50">Ответственное лицо<br />за информацию о препаратах</span>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactsPage;
